import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { ExternalLink } from 'lucide-react';
import useBrandName from '@/hooks/use-brand-name';
import ApplicationImg from '@/assets/images/avantages/dekra_phone.png'
import LogosImg from '@/assets/images/avantages/DEKRA-NORISKO-AUTOCONTROL.jpg'

const Dekra = () => {
    const brandName = useBrandName();
    return (
        <div className="mt-6">
            <Card>
                <CardContent className="p-6">
                    <div className="grid grid-cols-1 md:grid-cols-12 gap-6">
                        <div className="md:col-span-4">
                            <img src={ApplicationImg} alt="Dekra Automotive" className="w-full rounded-lg" />
                        </div>
                        <div className="md:col-span-8">
                            <img src={LogosImg} alt="Logos Dekra Norisko Autocontrol" className="max-w-[400px] w-full" />
                            <h3 className="text-primary font-bold mt-6 text-lg">
                                Bénéficiez de 15% de réduction sur votre Contrôle Technique grâce à votre contrat {brandName}
                            </h3>
                            <p className="mt-6 text-muted-foreground">
                                Grâce à ce partenariat entre {brandName} et DEKRA Automotive (DEKRA, NORISKO, AUTOCONTROL), profitez d'un service fiable et rapide dans un réseau reconnu pour réaliser votre Contrôle Technique 2-roues.
                            </p>

                            <p className="mt-6 font-semibold">Comment en bénéficier ?</p>
                            <ul className="mt-2 space-y-2 text-sm text-muted-foreground list-disc list-inside">
                                <li>
                                    Prenez rendez-vous en ligne en cliquant sur <a href="https://www.dekra-norisko.fr/aprilmoto?code=a230b13bc8ecb4c4430c66fbec8220658f94882294be66f8d00bb50b40fcba736a34b4c65415704caaeb15a0dc3e75587ff8fa67a3ddc5013f958dc3626b1f0f" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline" aria-label="Prendre rendez-vous contrôle technique Dekra">ce lien</a>. Choisissez votre centre et votre RDV, la remise s'appliquera automatiquement lors du paiement.
                                </li>
                                <li>
                                    Si vous prenez RDV directement en centre ou par téléphone, communiquez le code partenaire <strong className="text-primary">CTAPRILMOTO</strong>.
                                </li>
                                <li>
                                    Le jour du contrôle technique présentez un justificatif d'assurance {brandName} (mémo assurance, email, espace assuré…).
                                </li>
                            </ul>

                            <Button asChild className="mt-6 cursor-pointer">
                                <a target="_blank" rel="noopener noreferrer" href="https://www.april-moto.com/avec-april-moto-beneficiez-de-15-sur-le-controle-technique-de-votre-2-roues/" className="no-underline text-white" aria-label="Détails de l'offre Dekra">
                                    <ExternalLink className="w-4 h-4" aria-hidden="true" />
                                    Détails de l'offre
                                </a>
                            </Button>
                        </div>
                    </div>
                </CardContent>
            </Card>
        </div>
    );
};

export default Dekra;
